import { CheckCircle2 } from "lucide-react";
interface TabCompletionHeaderProps {
  title: string;
  completion: number;
  statusLabel: string;
}

export function TabCompletionHeader({ title, completion, statusLabel }: TabCompletionHeaderProps) {
  return (
    <div className="mb-6 bg-white rounded-[10px] border border-slate-200 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] p-6 flex items-center gap-4">
      <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-2xl bg-[#00444C]/10">
        <CheckCircle2 className="h-5 w-5 text-[#00444C]" />
      </div>
      <div className="min-w-0">
        <h3 className="truncate text-base font-bold leading-6 text-slate-900">{title}</h3>
        <p className="mt-1 text-sm font-normal leading-5 text-slate-500">
          {completion}% {"Completion".toLowerCase()} • {statusLabel}
        </p>
      </div>
    </div>
  );
}
